import { useCallback } from 'react'

import AuthHelper from 'helpers/auth_helper'
import StringHelpers from 'helpers/string_helpers'
import { useRootContext } from 'hooks/use_context'

const useSignUpByEmail = ({ setError, email, password, onClose }) => {
  const rootContext = useRootContext()

  const onLoginError = useCallback(
    (err) => {
      rootContext.setLoading(false)
      if (JSON.parse(err.responseText)) return setError(err.responseJSON.message)
      setError('We are having problems processing your request, please try again later.')
    },
    [rootContext.disableLoad, setError]
  )

  const onLoginSuccess = useCallback(async () => {
    rootContext.setLoading(false)
    onClose()
    await rootContext.onAuthSuccess()
    AuthHelper.performLoginRedirect()
  }, [rootContext.onAuthSuccess])

  const onPerformLogin = useCallback(
    (params) => {
      rootContext.setLoading(true)
      setError('')
      params.client = 'desktop'
      AuthHelper.performLogin(params, onLoginSuccess, onLoginError)
    },
    [setError, rootContext.enableLoad]
  )

  return useCallback(
    (e) => {
      e.preventDefault()
      if (!StringHelpers.validateEmail(email)) return setError('Please provide a valid email')
      onPerformLogin({ email, password })
    },
    [setError, onPerformLogin, email, password]
  )
}

export default useSignUpByEmail
